import React from 'react';
import { Popup } from 'devextreme-react/popup';
import { injectIntl } from "react-intl";
import * as assetCrud from '../../../../crud/asset.crud';
import { boolOptions, contractUserPartyOptions } from '../../../../shared/lookup';
import sanitizeHtml from 'sanitize-html-react';
import Common from '../../../../shared/common';
import DataGridBase from "../../../../partials/layout/DataGridBase";
import { withSnackbar } from 'notistack';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import { Alert } from "react-bootstrap";
import moment from 'moment';

class AssetChain extends React.Component {
    constructor() {
        super();
        this.state = {
            assets: null,
            lastUpdatedDatetime: null
        };
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isOpen && this.props.isOpen) {
            this.getChained();
        }
    }

    getChained = async () => {
        assetCrud.getChained(this.props.contractid, this.props.assetid)
            .then(response => {
                const expirationDateTime = response.data.AbsoluteExpiration;
                const lastUpdatedDatetime = expirationDateTime ? moment(expirationDateTime).local().subtract(5, 'minutes').format("YYYY-MM-DD HH:mm:ss") : moment().format("YYYY-MM-DD HH:mm:ss");
                let assets = response.data.Value ? response.data.Value : response.data;
                assets = assets.filter(r => r.Draft !== 1).filter(obj => this.props.contractTemplate.accessibleWfIds.includes(obj.WorkflowID));
                this.setState({ assets, lastUpdatedDatetime });
            })
            .catch(err => {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            });
    }

    onClose = () => {
        this.props.onClose();
    }

    calculateHTML = (dataField) => {
        return (cellInfo) => {
            if (!cellInfo || !cellInfo[dataField]) {
                return "";
            }
            
            const cleanHTML = sanitizeHtml(cellInfo[dataField]); 
            return Common.HtmlToString(cleanHTML);
        };
    }

    calculateUrl = (cellElement, cellInfo) => {
        const { data } = cellInfo;
        
        const wf = this.props.contractTemplate.workflowsQA[data.WorkflowID];

        let url = "";

        if (data.PK && wf) {
            url = process.env.PUBLIC_URL + wf.paths.basePath + data.PK;
        }
    
        cellElement.innerHTML = `<a href="${url}" style="white-space: normal;"><strong>${data.ReferenceID}</strong></a>`;
    }

    calculateLink = (rowData) => {
        const wf = this.props.contractTemplate.workflowsQA[rowData.WorkflowID];

        let url = "";

        if (rowData.PK && wf) {
            url = process.env.PUBLIC_URL + wf.paths.basePath + rowData.PK;
        }

        return url;
    }

    render() {
        if (!this.props.isOpen) {
            return null;
        }
        const columns = [
            { caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.REFERENCE_ID' }), dataField: "ReferenceID", cellTemplate: this.calculateUrl },
            { caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.NOTIFICATION_TITLE' }), dataField: "NotificationTitle", dataType: 'string' },
            { caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.SUBJECT' }), dataField: "Subject", dataType: 'string' },
            { caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.DESCRIPTION' }), dataField: "Description", dataType: 'string', calculateCellValue: this.calculateHTML("Description") },
            { caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.NOTIFIED_BY' }), dataField: "NotifiedBy", dataType: 'string' },
            { caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.DATE_NOTIFIED' }), dataField: "DateNotified", dataType: 'date', format: 'dd/MM/yyyy' },
            { caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.REPLY' }), dataField: "Reply", dataType: 'string', lookup: { dataSource: boolOptions, valueExpr: 'value', displayExpr: 'display' } },
            { caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.SENDING_PARTY' }), dataField: "Party", dataType: 'string', lookup: { dataSource: contractUserPartyOptions, valueExpr: 'id', displayExpr: 'display' } },
            { caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.TYPE' }), dataField: "Type", dataType: 'string', calculateCellValue: this.calculateHTML("Type") },
            { caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.LINK' }), dataField: "url", calculateCellValue: this.calculateLink, visible: false, showInColumnChooser: false }
        ];

        return (
            <Popup
                visible={this.props.isOpen}
                onHiding={this.onClose}
                dragEnabled={true}
                hideOnOutsideClick={true}
                showCloseButton={true}
                showTitle={true}
                title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.ASSET_CHAIN' })}
                width={'90%'}
                height='90vh'
            >
                <Portlet style={{ width: "inherit" }}>
                    <PortletBody>
                        <Alert variant="secondary">
                            <p>
                                {this.props.intl.formatMessage({ id: 'GENERAL.FORMS.RELATIONSHIP_ASSET_CHAIN.WARNING_CACHE' }, { MINUTES: 5, DATETIME: this.state.lastUpdatedDatetime })}
                            </p>
                        </Alert>
                        <DataGridBase
                            version="2"
                            width='100%'
                            height='100%'
                            dataSource={this.state.assets}
                            keyExpr="PK"
                            hoverStateEnabled={false}
                            rowAlternationEnabled={true}
                            noDataText={'No Data'}
                            showBorders={true}
                            showColumnLines={true}
                            showRowLines={true}
                            remoteOperations={false}
                            columns={columns}
                            name="Asset Chain"
                        />
                    </PortletBody>
                </Portlet>
            </Popup>
        );
    }
}

export default injectIntl(withSnackbar(AssetChain));